import {
  Alert,
  AlertIcon,
  AlertDescription,
  Stack,
  Spinner,
  Button,
  AlertTitle,
  Container,
} from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { TODO } from '@habity/types';
import { isProfileRoute } from '@habity/utils';
import { usePathname } from 'next/navigation';

export const HeaderAlert = ({
  icon,
  isLoading,
  title,
  description,
  cta,
  px = { base: '0', sm: '0', md: '12', lg: '12' },
  borderRadius = 'none',
  onClick,
}: {
  icon: IconType;
  isLoading: boolean;
  title?: string;
  description?: string;
  cta?: string;
  px?: TODO;
  borderRadius?: TODO;
  onClick: () => void;
}) => {
  const pathname = usePathname();
  return (
    <Alert
      status="warning"
      variant="subtle"
      fontSize="sm"
      py="2"
      borderRadius={borderRadius}
    >
      <Container
        px={px}
        maxW={pathname && isProfileRoute(pathname) ? '7xl' : 'full'}
      >
        <Stack direction="row">
          {isLoading ? (
            <Spinner mr="1" mt="1" size="sm" />
          ) : (
            <AlertIcon color="black" mr="0" as={icon} />
          )}
          {title && <AlertTitle>{title}</AlertTitle>}

          {description && <AlertDescription>{description}</AlertDescription>}

          {cta && (
            <Button colorScheme="brand" onClick={onClick} size="xs">
              {cta}
            </Button>
          )}
        </Stack>
      </Container>
    </Alert>
  );
};
